import {Injectable} from '@angular/core';

@Injectable()
export class TaskBarService {

  isOpen = false;

  openTaskBar() {
    this.isOpen = !this.isOpen;
    localStorage.setItem('TaskBar', String(this.isOpen));
  }

  closeTaskBar() {
    this.isOpen = false;
  }

  setTaskBar(f) {
    this.isOpen = f;
  }


}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/services/task-bar.service.ts